<template>
  <div class="bm-profile">
    <h1>{{ msg }}</h1>
    <h3>Hello, <span>{{ user.nickName }}</span></h3>
    <div class="avatar">
      <img :src="user.avatar">
    </div>
    <!--<cube-button :primary="true" @click="logout()">退出登录</cube-button>-->
    <router-link :to="{name: 'Index'}" class="router-go" >返回首页</router-link>
    <van-button type="primary" @click="signUp" class="sign-up" >报名</van-button>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { ImageFormat } from '@/utils'
import { getInfo } from '@/api/user'
import { getPassport } from '@/libs/passport'
import { Button } from 'vant'

Vue.use(Button)

export default {
  name: 'Home',
  data () {
    return {
      msg: '个人中心',
      user: {}
    }
  },
  created() {
    if (this.$route.query && this.$route.query.action) {
      this.signUp()
    }

    this.wxShare({
      title: '个人中心',
      link: window.location.href,
      image: 'http://www.snsports.cn/activity/shifa/data/daiyan-share-logo.png',
      abstract: '个人中心个人中心个人中心个人中心个人中心'
    })
  },
  methods: {
    fetchData() {
      // this.listLoading = true
      getInfo().then(
        response => {
          this.user = response.data.users
          this.user.avatar = ImageFormat.imageView(this.user.avatar, 100, 100, 1)
          // this.listLoading = false
        }
      )
    },
    logout() {
      store.dispatch('LogOut').then(() => {
        this.$router.push({ path: '/' })
      })
    },
    signUp() {
      this.$router.push({ query: Object.assign({}, this.$route.query, { action: 'signUp' }) })
      getPassport().then((response) => {
        if (response) {
          this.fetchData()
          console.log('报名成功')
        }
      })
    },
    reload() {
      location.reload()
    }
  }
}
</script>

<style lang="css">
  .bm-profile {
    background: white;
  }
  .bm-profile h1 {
    font-weight: normal;
    color: black;
    margin: 0;
    padding: 15px 15px 0;
  }
  .bm-profile h3 {
    padding: 0 15px;
    font-size: 14px;
    color: #3b3b3b;
  }
  .bm-profile h3 span {
    color: #000000;
  }
  .bm-profile .avatar img {
    border-radius: 50%;
    padding: 15px;
  }
  .bm-profile .router-go {
    color: #3b3b3b;
    padding: 15px;
  }

  .bm-profile .sign-up {
    display: block;
    width: calc(100% - 80px);
    margin: 30px auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/profile/index.vue